
import "swiper/css/swiper.css";
import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { QnaVO } from "@/views/biz/product/vo/qna.vo";
import { ProductVO } from "@/views/biz/product/vo/product.vo";

@Component
export default class MyQna extends Vue {
  inquiryHistoryList: Array<QnaVO> = [] as Array<QnaVO>;

  //computed
  get content() {
    if (!this.inquiryHistoryList.length) {
      return [];
    }
    this.inquiryHistoryList.forEach((v) => {
      v.qcontents && (v.qcontents = v.qcontents.replace(/\n/g, "<br>"));
    });
    return this.inquiryHistoryList;
  }

  btnMore(index: number) {
    this.inquiryHistoryList.forEach((item: QnaVO, i: number) => {
      if (index == i) {
        item.isExpand = !item.isExpand;
      } else {
        item.isExpand = false;
      }
      this.$set(this.inquiryHistoryList, i, item);
    });
  }
  
  // 삭제
  deleteQna(item: QnaVO) {
    // 삭제하시겠습니까?
    if(confirm(this.$t('common.c0004').toString()) == false) {
      return;
    }

    axios.delete(`mypage/profile/inquiry-history`, {params: {seq: item.seq}}).then(r=>{
      this.search();
      // 삭제되었습니다.
      alert(this.$t('mypage.a0013'));
    })
  }

  search() {
    // 문의내역
    axios.get("/mypage/profile/inquiry-history").then((r) => {
      this.inquiryHistoryList = r.data;
    });
  }

  //initialized events
  created(): void {
    this.search(); 
  }
}
